import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=559663c2&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559663c2')) {
      api.createRecord('559663c2', component.options)
    } else {
      api.reload('559663c2', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=559663c2&", function () {
      api.rerender('559663c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Information.vue"
export default component.exports